import { RotatePhone } from 'assets/icons';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { SectionNavigation } from 'shared/constants/common';
import useSectionNavigation from 'shared/hooks/useSectionNavigation';
import { handleAddOverflow, handleRemoveOverflow, isMobile, isTablet } from 'shared/util/utility';

const Orientation: React.FC = (props) => {
	const [show, setShow] = useState(false);
	const { t } = useTranslation();
	const { isViewActive } = useSectionNavigation();

	useEffect(() => {
		const showDiv = () => {
			appHeight();
			document.getElementsByTagName('button')[0]?.focus();
			if (isTablet()) {
				setShow(false);
			} else if (isMobile() && window.orientation === 90) {
				setShow(true);
				// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
				document.getElementsByTagName('body')[0]!.style.setProperty('--scroll-position', '0px');
				handleAddOverflow();
			} else {
				setShow(false);
				isViewActive(SectionNavigation.HOME) && handleRemoveOverflow();
			}
		};
		showDiv();
		window.addEventListener('orientationchange', showDiv);
		return () => {
			window.removeEventListener('orientationchange', showDiv);
		};
	});

	const appHeight = () => {
		const doc = document.documentElement;
		document.body.style.setProperty('--screen-height', `${window.innerHeight}px`);
		doc.style.setProperty('--app-height', `${window.innerHeight}px`);
	};

	return (
		<>
			{show && (
				<div className="orientation flex align__items--center justify__content--center">
					<div className="text--center">
						<RotatePhone className="rotate-phone--icon" />
						<p className="font-size--lg text--white font--semi-bold mb--5">{t('rotatePhone')}</p>
						<p className="font-size--sm text--white font--semi-bold mt--0">{t('portraitNotSupportMessage')}</p>
					</div>
				</div>
			)}
			{props.children}
		</>
	);
};

export default Orientation;
